import { useTranslation } from 'next-i18next';

import { ProductPrice } from '../../../ProductPrice/ProductPrice';
import { CurrencyCode } from '../types';
import { priceSign } from '../utils/framePricing';
import { FramingChange } from '../utils/framingChanges';

export interface FramingChangesProps {
  changes: FramingChange[];
  total: number;
  currencyCode?: CurrencyCode;
}

const SignedPrice = ({
  amount,
  currencyCode,
}: {
  amount: number;
  currencyCode?: CurrencyCode;
}) => {
  return (
    <ProductPrice
      currencyCode={currencyCode}
      isFloat
      prefix={priceSign(amount)}
      price={Math.abs(amount)}
      skipConvertCurrency={!!currencyCode}
      skipTaxCalculation
    />
  );
};

export const FramingChanges = ({
  changes,
  currencyCode,
  total,
}: FramingChangesProps) => {
  const { t } = useTranslation('checkout');

  return (
    <section className="grid gap-3">
      <h3 className="font-bold">{t('framing.changes.title')}</h3>

      {changes.length ? (
        <dl className="grid gap-2">
          {changes.map(({ from, part, priceDelta, to }) => (
            <div key={part} className="flex items-end justify-between gap-3">
              <dt className="min-w-0">
                {from && from !== to ? (
                  <>
                    <s className="text-neutral-4">{from}</s>{' '}
                  </>
                ) : null}
                {to}
              </dt>
              <dd className="shrink-0">
                <SignedPrice amount={priceDelta} currencyCode={currencyCode} />
              </dd>
            </div>
          ))}
        </dl>
      ) : null}

      <dl className="mt-3 flex justify-between gap-3">
        <dt>{t('framing.changes.total')}</dt>
        <dd className="shrink-0">
          <SignedPrice amount={total} currencyCode={currencyCode} />
        </dd>
      </dl>
    </section>
  );
};
